import {
   GET_SALE_CHALLAN,
   ADD_SALE_CHALLAN,
   UPDATE_SALE_CHALLAN,
   GET_SALE_CHALLAN_BY_ID,
   DELETE_SALE_CHALLAN,
   GET_LAST_SALE_CHALLAN_DAYBOOK,
   // GET_SALE_INVOICES_FOR_DAYBOOK,
   // GET_SALE_INVOICE,
   // GET_SALE_INVOICES_TRANSACTIONS,
   // ADD_SALE_INVOICE,
   // LAST_BILL_SALE_INVOICE,
   // SET_LOADING,
   // GET_ONE_SALE_INVOICE,
   // EMPTY_ONE_SALE_INVOICE,
   // GET_SALE_INVOICE_WITH_PREV_AND_NEXT,
   // GET_SALE_INVOICE_PREV_AND_NEXT,
   // GET_PENDING_VOUCHER_SALES_ADJUSTMENT,
   // GET_PENDING_SALES_ADJUSTMENT,
   // GET_PURCHASE_ADJUSTMENT,
   // GET_PENDING_VOUCHER_WITH_PURCHASE_ADJUSTMENT,
   // GET_ADJUSTED_DOCS,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   lastBill: null,
   isLoading: false,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   salesData: null,
   prevAndNext: null,
   pendingVoucherSalesAdjustment: [],
   pendingSalesAdjustment: [],
   pendingPurchaseAdjustment: [],
   pendingVoucherPurchaseAdjustment: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      // case SET_LOADING:
      //    return {
      //       ...state,
      //       isLoading: payload,
      //    };
      // case EMPTY_ONE_SALE_INVOICE:
      //    return {
      //       ...state,
      //       single: payload,
      //    };
      case GET_SALE_CHALLAN:
         return { ...state, list: payload.data, totalCount: totalCount, isLoading: false, pagination: action.payload.pagination };

      // case GET_SALE_INVOICES_FOR_DAYBOOK:
      //    return {
      //       ...state,
      //       listfordaybook: payload.data,
      //       totalCountfordaybook: totalCount,
      //       isLoadingfordaybook: false,
      //       paginationfordaybook: action.payload.pagination,
      //    };

      case GET_SALE_CHALLAN_BY_ID:
         return { ...state, single: payload || initialState.single, isLoading: false };

      // case GET_SALE_INVOICES_TRANSACTIONS:
      //    return {
      //       ...state,
      //       data: payload.data || initialState.single,
      //       isLoading: false,
      //    };

      case UPDATE_SALE_CHALLAN:
         return { ...state, list: state.list.map((item) => (item.id === payload.id ? payload : item)), isLoading: false };

      case ADD_SALE_CHALLAN:
         return { ...state, list: [payload, ...state.list], totalCount: state.totalCount + 1, isLoading: false };

      case DELETE_SALE_CHALLAN:
         return { ...state, list: state.list.filter((item) => item.id !== payload.id), totalCount: state.totalCount - 1, isLoading: false };

      // case LAST_BILL_SALE_INVOICE:
      //    return {
      //       ...state,
      //       lastBill: payload,
      //    };

      case GET_LAST_SALE_CHALLAN_DAYBOOK:
         return { ...state, lastSaleDaybook: payload };

      // case GET_ONE_SALE_INVOICE:
      //    return { ...state, single: payload };

      // case GET_SALE_INVOICE_PREV_AND_NEXT:
      //    return {
      //       ...state,
      //       prevAndNext: payload,
      //    };

      // case GET_SALE_INVOICE_WITH_PREV_AND_NEXT:
      //    return {
      //       ...state,
      //       salesData: { data: payload.data, pagination: payload.pagination, totalCount: payload.totalCount },
      //    };

      // case GET_PENDING_VOUCHER_SALES_ADJUSTMENT:
      //    return {
      //       ...state,
      //       pendingVoucherSalesAdjustment: payload,
      //       isLoading: false,
      //    };

      // case GET_PENDING_SALES_ADJUSTMENT:
      //    return {
      //       ...state,
      //       pendingSalesAdjustment: payload,
      //       isLoading: false,
      //    };

      // case GET_PURCHASE_ADJUSTMENT:
      //    return {
      //       ...state,
      //       pendingPurchaseAdjustment: payload,
      //       isLoading: false,
      //    };

      // case GET_PENDING_VOUCHER_WITH_PURCHASE_ADJUSTMENT:
      //    return {
      //       ...state,
      //       pendingVoucherPurchaseAdjustment: payload,
      //       isLoading: false,
      //    };

      // case GET_ADJUSTED_DOCS:
      //    return {
      //       ...state,
      //       adjusted: payload,
      //       isLoading: false,
      //    };

      default:
         return state;
   }
};

export default reducer;
